import Reflux from "reflux";
import Freezer from "freezer-js";
import envUtils from "../modules/env_utils";
import ReadingSessionActions from "../react_actions/reading_session_actions";
import ShelvingsActions from "../react_actions/shelvings_actions";
import { DEFAULT_SHELVES } from "../modules/default_shelves";
import { find, merge } from "lodash";

const INITIAL_STATE = {
  readingSessions: [],
  sessionBeingUpdatedId: null,
  loadMoreInProgress: false,
};

const state = new Freezer({});

const getState = () => state.get();

const resetTo = (data) => {
  getState().reset(merge({}, INITIAL_STATE, data));
};

const store = Reflux.createStore({
  listenables: [ReadingSessionActions,
                { bookShelved: ShelvingsActions.bookShelved }],
  getInitialState: state.get,
  getState,

  initializeWith(data) {
    resetTo(data);
  },

  reset() {
    resetTo({});
  },

  onBookShelved(resp) {
    if (resp && resp.shelfName === DEFAULT_SHELVES.READ.name && resp.reviewEditUrl) {
      envUtils.setLocationUrl(resp.reviewEditUrl);
    }
  },

  onUpdateProgress(session) {
    const data = {
      user_status: {
        book_id: session.book.bookId,
        body: session.body,
      },
    };
    data.user_status[session.positionType] = session.currentPosition;

    $j.post("/user_status.json", data)
      .done((resp) => {
        find(getState().readingSessions, { sessionId: session.sessionId }).set(resp);
        this.trigger(getState().set("sessionBeingUpdatedId", null));
      }).fail(() => {
        window.alert("An error has occurred. Please try again");
      });
  },

  getReadingSessionLoadOptions() {
    let options = {};
    if(this.getState().readingSessions.length !== this.getState().allReadingSessionsCount) {
      options = {
        limit : 3,
      };
    }
    return options;
  },

  onRefreshReadingSessions() {
    this.loadReadingSessions(this.getReadingSessionLoadOptions());
  },

  onLoadAllReadingSessions() {
    this.trigger(getState().set("loadMoreInProgress", true));
    this.loadReadingSessions();
  },

  loadReadingSessions(options = {}) {
    $j.get("/home/load_reading_sessions", options)
      .done((data) => {
        getState().set({
          readingSessions: data.readingSessions,
          allReadingSessionsCount: data.allReadingSessionsCount,
        });
        this.trigger(this.getState());
      })
      .always(() => {
        this.trigger(getState().set("loadMoreInProgress", false));
      });
  },

  onOpenUpdateProgressForm(sessionId) {
    this.trigger(getState().set("sessionBeingUpdatedId", sessionId));
  },

  onCloseUpdateProgressForm() {
    this.trigger(getState().set("sessionBeingUpdatedId", null));
  },

  onShelveBookSuccess() {
    this.trigger(getState().set("showSearchForm", false));
  },
});

export default store;
